'use client';

import {
  NavigationDrawerItem,
  NavigationDrawerRow,
  NavigationDrawerRowFigure,
  NavigationDrawerRowLabel,
  NavigationDrawerRowMain,
  NavigationDrawerRowMark,
} from '@vs-shop/commerce-ui/navigationDrawer';
import { ImageMissingPlaceholder } from '@vs-shop/ui/imageMissingPlaceholder';
import { coalesceNonEmpty } from '@vs-shop/domain/string/coalesceNonEmpty';
import { ChevronRight, Loader2 } from 'lucide-react';

import { resolveImageUrl } from '@vs-shop/engine/image/resolveImageUrl';

import Image from '@vs-shop/image-link/Image';

import type { TaxonMenu } from '../../../../effect/schema/openapi/backend';
import { ImageFilter } from '@vs-shop/engine/image/ImageFilter';

type Props = {
  taxon: TaxonMenu;
  isLoading: boolean;
  onClickAction: () => void;
};

// NOTE: we are displaying chevron icon every time because we dont know
// if the taxon has children before fetching it
export default function MobileNavigationItem({ taxon, isLoading, onClickAction }: Props) {
  const taxonImages = taxon.images ?? [];
  const image = taxonImages[0] ?? null;
  const imagePathAbstract = image?.pathAbstract ?? null;
  const imagePath =
    imagePathAbstract !== null
      ? resolveImageUrl(imagePathAbstract, ImageFilter.taxon_hamburger)
      : '';

  return (
    <NavigationDrawerItem>
      <NavigationDrawerRow variant="standard" onClick={onClickAction} disabled={isLoading}>
        <NavigationDrawerRowMain>
          <NavigationDrawerRowFigure variant="muted">
            {image !== null ? (
              <Image
                src={imagePath}
                alt={coalesceNonEmpty(taxon.metaTitle, taxon.name, taxon.nameInTaxonList) ?? ''}
                width={46}
                height={36}
                preload
              />
            ) : (
              <ImageMissingPlaceholder className="size-8" />
            )}
          </NavigationDrawerRowFigure>
          <NavigationDrawerRowLabel>{taxon.name}</NavigationDrawerRowLabel>
        </NavigationDrawerRowMain>

        <NavigationDrawerRowMark variant={isLoading ? 'busy' : 'static'}>
          {isLoading ? <Loader2 strokeWidth={1} /> : <ChevronRight strokeWidth={1} />}
        </NavigationDrawerRowMark>
      </NavigationDrawerRow>
    </NavigationDrawerItem>
  );
}
